import React, { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import { IS_DEMO } from '../config';

import { store } from './store';
import { VariablesProvider } from './variables-provider';

type Props = PropsWithChildren<{
  //
}>;

export const StoreProvider = ({ children }: Props) => {
  if (IS_DEMO) {
    return <Provider store={store}>{children}</Provider>;
  }

  return (
    <Provider store={store}>
      <VariablesProvider>{children}</VariablesProvider>
    </Provider>
  );
};
